import * as angular from 'angular';

import { Step } from './Step';
import { ComponentDefinition } from '../../models';

class GroupComputationController implements angular.IComponentController {
    steps: Step[];
}

export const wtGroupComputation: ComponentDefinition = {
    componentId: 'wtGroupComputation',
    controller: GroupComputationController,
    controllerAs: 'vm',
    template: require('./groupComputation.component.html'),
    bindings: {
        steps: '='
    }
};